<ng-container *ngIf="media.length; else empty">
  <ng-container *ngFor="let item of media">
    <sn-location-media-list-item
      [item]="item"
      (fileDeleted)="emitItem($event)"
    ></sn-location-media-list-item>
  </ng-container>
</ng-container>
<ng-template #empty>
  <sn-empty-state icon="cancel_presentation" [title]="'map.locations.locationMedia.noMedia' | t">
    {{ 'map.locations.locationMedia.noMediaMessage' | t }}
  </sn-empty-state>
</ng-template>
